import React from "react";
import { Link } from "gatsby";
import Logo from "./Logo";
import { EqualHousing, LinkedIn, Facebook, Instagram, ArrowUpRight } from "./Icons";
import site from "../data/site";
import programs from "../data/programs";
import { NAV_LINKS } from "./Nav";
import * as s from "./Footer.module.css";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className={`tone-navy ${s.footer}`}>
      <div className="container">
        <div className={s.top}>
          <div className={s.brandCol}>
            <Logo tone="light" size={1.05} />
            <p className={s.blurb}>{site.person.name} is an independent mortgage broker in {site.contact.city}, {site.contact.state}. Twelve years, nearly half a billion dollars closed, and a business built entirely on referrals.</p>
            <div className={s.contact}>
              <a href={`tel:${site.contact.phoneRaw}`}>{site.contact.phone}</a>
              <a href={`mailto:${site.contact.email}`}>{site.contact.email}</a>
              <span className={s.muted}>{site.contact.hours}</span>
            </div>
            <div className={s.social}>
              {site.social.linkedin && <a href={site.social.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn"><LinkedIn size={18} /></a>}
              {site.social.instagram && <a href={site.social.instagram} target="_blank" rel="noreferrer" aria-label="Instagram"><Instagram size={18} /></a>}
              {site.social.facebook && <a href={site.social.facebook} target="_blank" rel="noreferrer" aria-label="Facebook"><Facebook size={18} /></a>}
            </div>
          </div>
          <div className={s.col}>
            <h4 className={s.colTitle}>Navigate</h4>
            <ul>
              {NAV_LINKS.map((l) => <li key={l.to}><Link to={l.to}>{l.label}</Link></li>)}
              <li><Link to="/faq/">FAQ</Link></li>
              <li><Link to="/contact/">Contact</Link></li>
            </ul>
          </div>
          <div className={s.col}>
            <h4 className={s.colTitle}>Loan programs</h4>
            <ul>
              {programs.map((p) => <li key={p.slug}><Link to={`/loan-programs/#${p.slug}`}>{p.name}</Link></li>)}
            </ul>
          </div>
          <div className={s.col}>
            <h4 className={s.colTitle}>Licensed in</h4>
            <ul>
              {site.licensedStateNames.map((n) => <li key={n}><span>{n}</span></li>)}
            </ul>
            <a className={s.nmlsLink} href={site.person.nmlsUrl} target="_blank" rel="noreferrer">NMLS Consumer Access <ArrowUpRight size={14} /></a>
          </div>
        </div>
        <hr className="rule" />
        <div className={s.bottom}>
          <div className={s.eho}>
            <EqualHousing size={40} />
            <div className={s.legal}>
              <p><strong>{site.person.name}</strong>{site.compliance.licensing.replace(site.person.name, "")}{site.company.nmls ? ` ${site.company.legalName}, NMLS ${site.company.nmls}.` : ""}</p>
              <p>{site.compliance.disclaimer}</p>
              <p>{site.compliance.equalHousing}. © {year} {site.company.legalName}. All rights reserved. <Link to="/privacy/">Privacy</Link></p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
